import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  propsectDetails: {},
  quoteDetails: [],
};

const QuoteResponseSlice = createSlice({
  name: 'quoteResponse',
  initialState,
  reducers: {
    setQuoteResponse: (_state, action) => {
      return action.payload;
    },
    resetQuoteResponse: () => initialState,
  },
});

export const { setQuoteResponse, resetQuoteResponse } = QuoteResponseSlice.actions;
export default QuoteResponseSlice.reducer;
